import { observer } from 'mobx-react-lite'
import { CommonErrorBanner } from 'pages/settings/pages/compliance/ui/CommonErrorBanner/CommonErrorBanner'
import { useInternationalStepsContext } from 'pages/settings/pages/compliance/pages/international/context/internationalStepsContext'

export const ErrorBanner = observer(() => {
  const { errorMessage } = useInternationalStepsContext()

  return (
    <CommonErrorBanner
      errorMessage={errorMessage}
      title={'Here goes regulatory bundle rejection reason'}
    />
  )
})
